import {Component, Input, OnInit} from '@angular/core';
import {InsuranceSubscriptionService, InsuranceSubscriptionStatus} from '@lifeislife/lifeislife-domain';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {map, publishReplay, refCount, switchMap} from 'rxjs/operators';

@Component({
  selector: 'cf-insurance-subscription-status',
  templateUrl: './insurance-subscription-status.component.html',
  styleUrls: ['./insurance-subscription-status.component.scss'],
})
export class InsuranceSubscriptionStatusComponent implements OnInit {

  @Input()
  set status(value: InsuranceSubscriptionStatus) {
    this.value$.next(value);
  }

  value$ = new BehaviorSubject<InsuranceSubscriptionStatus>(null);
  label$: Observable<string>;

  constructor(
    private insuranceSubscriptionService: InsuranceSubscriptionService,
  ) {
  }

  ngOnInit(): void {
    this.label$ = this.value$.pipe(
      switchMap(s => s == null ? of(null) : this.insuranceSubscriptionService.getInsuranceSubscriptionStatusPublicLabel$(s)),
      publishReplay(1), refCount(),
    );
  }

}
